module.exports = __webpack_public_path__ + "static/media/reports_open_conflict_reports.3ed2f113.mov";